import './controls.css'

import React, { useState } from 'react';

export function Knob({min, max, value}) {
    const [rotation, setRotation] = useState(0);
    const [isMouseDown, setIsMouseDown] = useState(false);

    const handleRotate = (e) => {
        if (!isMouseDown) return;  // Only rotate if mouse is held down

        const rect = e.target.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);
        setRotation(angle);
    };

    const handleMouseDown = (e) => {
        setIsMouseDown(true);
        e.preventDefault();  // Prevent text selection on mouse down
    };

    const handleMouseUp = () => {
        setIsMouseDown(false);
    };

    const handleMouseLeave = () => {
        setIsMouseDown(false);  // Stop rotating if mouse leaves the knob area
    };

    return (
        <div
            className="knob-container"
            onMouseMove={handleRotate}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
        >
            <div className="knob" style={{ transform: `rotate(${rotation + 90}deg)` }}>
                <div className="indicator" />
            </div>
        </div>
    );
}